import {
  Box,
  BlockStack,
  InlineGrid,
  Text,
  Card,
  Divider,
  useBreakpoints,
  TextField,
  Button,
  ChoiceList,
  Avatar,
  InlineStack,
  Spinner,
  ButtonGroup,
  Icon,
  Toast,
  Badge,
  Tabs,
  Tag,
  Autocomplete,
  Banner,
} from '@shopify/polaris';
import {
  SettingsIcon,
  EditIcon,
  CheckIcon,
  ExternalIcon,
  LogoGoogleIcon,
  CashDollarIcon
} from '@shopify/polaris-icons'
import { doc, setDoc } from 'firebase/firestore';
import { useEffect, useState, useCallback } from 'react';

import ChooseASubscriptionPanel from '../components/ChooseASubscriptionPanel';
import AppLayout from '../components/layout';
import PostsLibrary from '../components/PostsLibrary';

// import TremendousPanel from '../components/TremendousPanel';
import { usePartnerUp } from '../providers/PartnerUpStoreProvider';


// This example is for guidance purposes. Copying it will come with caveats.
export default function Plan() {
  const {
    db,
    store,
    refetchStore,
    openBeacon,
    uploadFile,
    leads,
    pastPayments,
    user,
    refetchUser
  } = usePartnerUp();
  const { smUp, mdDown } = useBreakpoints();

  const [settingsTab, setSettingsTab] = useState(0)
  const [localStore, setLocalStore] = useState(store);
  const [localUser, setLocalUser] = useState(user);
  const [editingContactEmail, setEditingContactEmail] = useState(false);
  const [editingBasicInfo, setEditingBasicInfo] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [customDomainModalOpen, setCustomDomainModalOpen] = useState(false);
  const [toast, setToast] = useState(null);
  const [uploadLoading, setUploadLoading] = useState(false)

  const [localFilters, setLocalFilters] = useState(user?.filters || {
    ageGroups: [],
    genders: [],
    countries: []
  })

  const [logoFile, setLogoFile] = useState(null);
  const [squareLogoFile, setSquareLogoFile] = useState(null);


  useEffect(() => {
    if (store) {
      setLocalStore(store)
    }
  }, [store])

  useEffect(() => {
    if (user) {
      setLocalUser(user)
      if (user?.filters) {
        setLocalFilters(user?.filters)
      }
    }
  }, [user])

  const toggleActive = useCallback(() => setToast(null), []);
  const toastMarkup = toast ? (
    <Toast content={toast.content} error={toast.isError} onDismiss={toggleActive} />
  ) : null;


  return (
    <AppLayout>
      <InlineStack align="center">
        <Box maxWidth="1500px" width="1500px">
          <BlockStack
            gap="500"
          >
            <InlineStack align="space-between">
              <InlineStack gap="300" blockAlign="center">
                <InlineStack>
                  <Icon source={CashDollarIcon} />
                </InlineStack>
                <Text variant="headingXl">Plan</Text>
              </InlineStack>
            </InlineStack>
            {toastMarkup}
            <div style={{ marginBottom: '100px' }}>
              <BlockStack gap={{ xs: "800", sm: "1600" }}>
                <InlineGrid columns={{ xs: "1fr", md: "2fr 5fr" }} gap="400">
                  <Box
                    as="section"
                    paddingInlineStart={{ xs: 4, sm: 0 }}
                    paddingInlineEnd={{ xs: 4, sm: 0 }}
                  >
                    <BlockStack gap="400">
                      <Text as="h3" variant="headingXl">
                        Subscription
                      </Text>
                      <Text as="p" variant="bodyMd">
                        Your monthly subscription plan
                      </Text>
                    </BlockStack>
                  </Box>
                  <ChooseASubscriptionPanel />
                </InlineGrid>
              </BlockStack>
            </div>
          </BlockStack>
        </Box>
      </InlineStack>
    </AppLayout>
  );
}
